module.exports = "<footer class=\"app-footer\">\n  <span><a href=\"http://icstech.com.br\">ICS</a> &copy; 2020 ICSTech.</span>\n  <span class=\"ml-auto\">Powered by <a href=\"http://icstech.com.br\">ICS</a></span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/ITN/srvHCWaba/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main